
  import { Component, Vue ,Inject,Prop} from 'vue-property-decorator';
  import PageFooter from '@/components/page-footer.vue';
  import {
    imgHost
  } from "@/utils/config"
  @Component({  
    name: '',
    components: {
      PageFooter
    }
  })

  export default class ProductList extends Vue {
    @Prop({default:''}) modekey!:''
    private imgHost = imgHost
    private defaultimg='/image/1677658403671.png'
    @Inject() information:any
    @Inject() editinfo:any
    get editmsg(){
      return this.information.find(v=>{
        return v.key==this.modekey
      })
    }
  }
